var render = function render(){var _vm=this,_c=_vm._self._c;return _c('message-management',{attrs:{"delete-message":_vm.deleteMessage,"edit-message":_vm.editMessage,"get-applications":_vm.getApplications,"get-locations":_vm.getLocations,"get-message-details":_vm.getMessageDetails,"get-roles":_vm.getRoles,"get-users-from-role":_vm.getUsers,"on-download":_vm.onDownloadFile,"save-message":_vm.saveMessage}})
}
var staticRenderFns = []

export { render, staticRenderFns }